export const FETCH_ROLE_LIST = "FETCH_ROLE_LIST";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";